import React, { useContext, useEffect, useState } from 'react'
import { StyledVerifyEmail } from './VerifyEmail.styled'
import { useSelector } from 'react-redux'
import { AppState } from '@news-mono/web-common'
import { UserSettingsLink } from '../components/UserSettingsLink'
import { tokens } from '@news-mono/design-tokens'
import { useSendVerifyEmail } from '../hooks/useSendVerifyEmail'
import { MyAccountContext } from '../hooks/useMyAccountContext'

export const VerifyEmail = () => {
    const TIME_INTERVAL = 60
    const { userEmail, auth0UserId, wanUserId } = useSelector(
        (state: AppState) => state.authentication,
    )
    const { mutateAsync: sendEmail } = useSendVerifyEmail(
        auth0UserId || wanUserId,
    )

    const [seconds, setSeconds] = useState<number>(TIME_INTERVAL)
    const [isCounting, setIsCounting] = useState<boolean>(true)
    const ctx = useContext(MyAccountContext)

    function resetTimer() {
        setSeconds(TIME_INTERVAL)
        setIsCounting(true)
    }

    // Countdown timer
    useEffect((): (() => void) => {
        // `setInterval` Type would be number if uses window.setInterval()
        let interval: null | NodeJS.Timeout = null
        if (isCounting) {
            interval = setInterval(() => {
                setSeconds((seconds) => {
                    if (seconds > 1) {
                        return seconds - 1
                    } else {
                        interval && clearInterval(interval)
                        setIsCounting(false)
                        return TIME_INTERVAL
                    }
                })
            }, 1000)
        } else {
            interval && clearInterval(interval)
        }
        return () => interval && clearInterval(interval)
    }, [isCounting, seconds])

    async function onResendClick() {
        if (isCounting) return
        const response = await sendEmail()
        if (!response) {
            ctx.setMessageBanner({
                text: 'Failed to send email.',
                type: 'error',
            })
        }
        resetTimer()
    }
    return (
        <StyledVerifyEmail>
            <p>
                We’ve sent a verification link to <span>{userEmail}</span>
            </p>
            <p>
                Please check your inbox to complete the process and update your
                email securely.
            </p>
            <p>
                Don't see the email? Check your spam folder or resend the email.
            </p>
            <UserSettingsLink onClick={onResendClick} disabled={isCounting}>
                Resend Link
            </UserSettingsLink>
            {isCounting && <small> in {seconds} second(s)</small>}
        </StyledVerifyEmail>
    )
}
